import axios from 'axios';
import config from './config.js'

const configs = config.config

const endpoint =  configs.host

const services = {

    get : async function(route, params){
        let url = endpoint + route
        return await axios.get(url,
          { 
            params : params,
            headers : {
              "Content-Type" : "application/json"
            }
          }, 
          ).then( response => {
          return response.data ? response.data : null
        }).catch( (error)=>{
          console.log('error', error)
          if(error.response && error.response.data){
            let e =  error.response.data
            if(e.error)
              return e
            else
              return {error : true, statusCode : error.response.status, message : error.response.data}
          }else{
            return {error : true, message : "Internal Server Error"}
          }
        }); 
    },

    post : async function (route, data){
      let url = endpoint + route
      return await axios({
        method: 'post',
        url: url ,
        withCredentials : false,
        data: data
    }).then((response)=>{
        return response.data ? response.data : null
      }).catch((error)=>{
        console.log('error',error.toString())
        if(error.response && error.response.data){
          let e =  error.response.data
          if(e.error)
            return e
          else
            return {error : true, statusCode : error.response.status, message : error.response.data}
        }else{
          return {error : true, message : "Internal Server Error"}
        }      
      })
    
    }
}
 
export default services
